export const TAG_BADGE_CLASS_NAME =
  'inline-flex max-w-full items-center gap-1.5 rounded-full border border-[#E5E7EB] bg-[#F3F4F6] px-2.5 py-1 !text-[11px] font-medium text-[#374151] dark:border-border/60 dark:bg-muted/45 dark:text-foreground';

const TAG_SPLIT_PATTERN = /[,;]+/;

export const normalizeTagName = (value) =>
  String(value ?? '')
    .replace(/\s+/g, ' ')
    .trim();

export const getTagKey = (value) => normalizeTagName(value).toLowerCase();

export const normalizeTagOption = (item) => {
  if (!item && item !== 0) {
    return null;
  }

  if (typeof item === 'string' || typeof item === 'number') {
    const normalized = normalizeTagName(item);

    return normalized
      ? {
          value: normalized,
          label: normalized,
        }
      : null;
  }

  const labelSource =
    item?.label ??
    item?.name ??
    item?.tagName ??
    item?.tag_name ??
    item?.text ??
    item?.value ??
    item?.id;
  const valueSource =
    item?.value ??
    item?.id ??
    item?.tagId ??
    item?.tag_id ??
    item?.key ??
    labelSource;
  const label = normalizeTagName(labelSource);
  const value = normalizeTagName(valueSource);

  if (!label && !value) {
    return null;
  }

  const normalizedValue = value || label;
  const normalizedLabel = label || normalizedValue;

  return {
    value: normalizedValue,
    label: normalizedLabel,
  };
};

export const normalizeTagList = (input) => {
  const items = Array.isArray(input)
    ? input
    : typeof input === 'string'
      ? input.split(TAG_SPLIT_PATTERN)
      : input
        ? [input]
        : [];

  const uniqueTags = new Map();

  items.forEach((item) => {
    const normalized = normalizeTagOption(item);

    if (!normalized) {
      return;
    }

    uniqueTags.set(getTagKey(normalized.value || normalized.label), normalized);
  });

  return Array.from(uniqueTags.values());
};

export const mergeTagOptions = (...collections) => {
  const merged = new Map();

  collections.forEach((collection) => {
    normalizeTagList(collection).forEach((tag) => {
      merged.set(getTagKey(tag.value || tag.label), tag);
    });
  });

  return Array.from(merged.values());
};

export const getTagNames = (tags) =>
  normalizeTagList(tags).map((tag) => normalizeTagName(tag.label || tag.value));

export const extractRolloutTags = (item) =>
  normalizeTagList(
    item?.tags ??
      item?.rolloutTags ??
      item?.tagNames ??
      item?.tag_names ??
      item?.rollout_tags ??
      item?.labels ??
      item?.metadata?.tags ??
      item?.raw?.tags ??
      item?.raw?.rolloutTags ??
      item?.raw?.tagNames
  );

export const tagsMatchFilter = (rolloutTags, selectedTags) => {
  const filters = normalizeTagList(selectedTags);

  if (filters.length === 0) {
    return true;
  }

  const availableKeys = new Set(
    normalizeTagList(rolloutTags).map((tag) => getTagKey(tag.value || tag.label))
  );

  return filters.every((tag) =>
    availableKeys.has(getTagKey(tag.value || tag.label))
  );
};

export const getTagSearchText = (tags) => getTagNames(tags).join(' ');
